// Vendors
import styled from 'styled-components';
import { mobileGridMediaQuery, tabletGridMediaQuery } from '@openbank/cf-ui-framework';
// Types
import { TestIdPropsType } from 'types/test-id.type';

export const DownloadAppModalContainer = styled.div.attrs(({ testId }: TestIdPropsType) => ({
  ...(testId ? { 'data-testid': testId } : {}),
}))`
  width: 100%;

  ${tabletGridMediaQuery} {
    & > div > div {
      gap: ${({ theme }) => theme.spaces.spacingM};
    }
  }

  ${mobileGridMediaQuery} {
    & > div > div {
      padding: ${({ theme }) => theme.spaces.spacingS};
      gap: ${({ theme }) => theme.spaces.spacingM};
    }
  }
`;

export const DownloadAppModalWrapper = styled.div.attrs(({ testId }: TestIdPropsType) => ({
  ...(testId ? { 'data-testid': testId } : {}),
}))`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mobileGridMediaQuery} {
    gap: ${({ theme }) => theme.spaces.spacingM};
  }
`;

export const AssetWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  span {
    width: 100%;
  }

  img {
    width: 100%;
    height: auto;
  }
`;
